/** Display labels only; keep the IANA identifier for date calculations and saves. */
export function formatTimezoneLabel(timezone?: string | null): string {
  return timezone === 'America/Sao_Paulo' ? 'Horário de Brasília' : timezone ?? '';
}
